import { render, staticRenderFns } from "./fileView.vue?vue&type=template&id=573cbe60&"
import script from "./fileView.vue?vue&type=script&lang=js&"
export * from "./fileView.vue?vue&type=script&lang=js&"
import style0 from "./fileView.vue?vue&type=style&index=0&id=573cbe60&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports